<template>
<div class="comment-vote" data-cx-clickarea="comment-vote">
  <button class="btn btn-good" type="button" @click="vote('good')" :disabled="voteDisabled">
    <svg class="icon icon-good" width="18" height="16" viewBox="1996 1978 22 20" fill-rule="evenodd">
      <title>good</title>
      <path d="M1,21H5V9H1ZM23,10a2.006,2.006,0,0,0-2-2H14.69l.95-4.57.03-.32a1.505,1.505,0,0,0-.44-1.06L14.17,1,7.59,7.59A1.955,1.955,0,0,0,7,9V19a2.006,2.006,0,0,0,2,2h9a1.987,1.987,0,0,0,1.84-1.22l3.02-7.05A1.976,1.976,0,0,0,23,12V10.09l-.01-.01Z" transform="translate(1995 1977)"></path>
    </svg><span class="btn-text">{{compGood}}</span>
  </button>
  <button class="btn btn-bad" type="button" @click="vote('bad')" :disabled="voteDisabled">
    <svg class="icon icon-bad" width="18" height="16" viewBox="2074 1978 22 20" fill-rule="evenodd">
      <title>bad</title>
      <g transform="translate(1780 1514)">
        <path d="M15,3H6A1.987,1.987,0,0,0,4.16,4.22L1.14,11.27A1.976,1.976,0,0,0,1,12v1.91l.01.01L1,14a2.006,2.006,0,0,0,2,2H9.31l-.95,4.57-.03.32a1.505,1.505,0,0,0,.44,1.06L9.83,23l6.59-6.59A1.987,1.987,0,0,0,17,15V5A2.006,2.006,0,0,0,15,3Zm4,0V15h4V3Z" transform="translate(293 461)"/>
      </g>
    </svg><span class="btn-text">{{compBad}}</span>
  </button>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'commentVote',
  props: {
    good: Number,
    bad: Number,
    uuid: String,
    replyKey: String
  },
  data: function () {
    return {
      voteDisabled: false
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      // pageの切り替わり時に disabledを引き継がないように
      const activeVoteBtnElm = document.querySelectorAll('.comment .comment__footer .comment-vote .btn')
      activeVoteBtnElm.forEach(function (btnItem) {
        btnItem.disabled = false
      })
    })
  },
  computed: {
    ...mapState('userData', ['user']),
    compGood: function () {
      return this.voteFormatter(this.good)
    },
    compBad: function () {
      return this.voteFormatter(this.bad)
    }
  },
  methods: {
    ...mapActions('commentsData', ['commentVote']),
    ...mapActions('modal', ['siteloginModal', 'siteRankupModal']),
    vote: function (goodBad) {
      // console.log(this.uuid, 'goodBadUuid')
      // console.log(this.replyKey, 'goodBadReplyKey')
      // console.log(goodBad, 'goodBad')

      // console.log(this[goodBad], '読み込みテスト')

      const payload = {
        'goodBad': goodBad,
        'uuid': this.uuid,
        'replyKey': this.replyKey
      }

      // ロール判定
      if (this.user.role === 'low' || this.user.role === 'middle') {
        // goodかbadか判定必要
        // this.commentVote({'goodBad': goodBad, 'uuid': this.uuid, 'replyKey': this.replyKey})
        // 押した時に処理
        this[goodBad]++
        this.voteDisabled = true

        // 通信を待って処理
        this.commentVote(payload).then(function (isVoteSuccess) {
          // console.log('voteからの戻り', isVoteSuccess)
          if (isVoteSuccess) { // 成功
            // console.log('vote成功')
          } else { // 失敗
            // console.log('vote失敗')
            this[goodBad]--
            this.voteDisabled = false
          }
        }.bind(this))
      } else if (this.user.idOnly) {
        this.siteRankupModal('newsGB')
      } else {
        this.siteloginModal('newsGB')
      }
    },
    voteFormatter (num) {
      // k,Mのみ対応
      // 参考：https://stackoverflow.com/questions/9461621/how-to-format-a-number-as-2-5k-if-a-thousand-or-more-otherwise-900-in-javascrip
      if (num >= 1000000) {
        return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M'
      }
      if (num >= 1000) {
        return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K'
      }
      return num
    }
  }
}
</script>

<style lang="scss" src="./commentVote.scss"></style>



// WEBPACK FOOTER //
// src/components/molecules/commentVote/commentVote.vue